import * as React from "react";
const SvgBattery4Bar = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  d: "M17 4v18H7V4h3V2h4v2h3zm-2 2H9v6h6V6z",
  fill: "currentColor"
}));
export default SvgBattery4Bar;